import { render, staticRenderFns } from "./MenuSettingModal.vue?vue&type=template&id=1bef29c6&scoped=true&"
import script from "./MenuSettingModal.vue?vue&type=script&lang=js&"
export * from "./MenuSettingModal.vue?vue&type=script&lang=js&"
import style0 from "./MenuSettingModal.vue?vue&type=style&index=0&id=1bef29c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef29c6",
  null
  
)

export default component.exports